import { store } from '../store/store';

enum CommonSubdomains {
	INTEGRATION = '.integration',
	STAGING = '.staging',
	SANDBOX = '.sandbox',
}

export enum Environments {
	INTEGRATION = 'integration',
	STAGING = 'staging',
	SANDBOX = 'sandbox',
	PRODUCTION = 'production',
}

const getIndependentEnv = (extractedEnv: string) => {
	// this is because of env as de2, uk1 and etc
	if (
		extractedEnv === CommonSubdomains.INTEGRATION ||
		extractedEnv === CommonSubdomains.STAGING ||
		extractedEnv === CommonSubdomains.SANDBOX
	) {
		return extractedEnv;
	}

	return '';
};

export const getProjectSubdomain = (isIndependent = false): string => {
	const hostname: string = window.location.hostname;
	let projectSubdomain = ''; // By default - equivalent to "cms.sportal365.com" hostname

	if (hostname === 'localhost') {
		projectSubdomain = CommonSubdomains.STAGING;
	} else {
		const projectSubdomainRegex = /cms([.\w]+)\.sportal365\.com/;
		const regexExecResult = projectSubdomainRegex.exec(hostname);

		if (regexExecResult) {
			projectSubdomain = isIndependent ? getIndependentEnv(regexExecResult[1]) : regexExecResult[1];
		}
	}

	return projectSubdomain;
};

const REACT_APP_URLS = (function () {
	let REACT_APP_ENV: Environments = Environments.PRODUCTION;
	const projectSubdomain = getProjectSubdomain();

	if (projectSubdomain === CommonSubdomains.INTEGRATION) {
		// Integration-specific settings
		REACT_APP_ENV = Environments.INTEGRATION;
	} else if (projectSubdomain === CommonSubdomains.STAGING) {
		// Staging-specific settings
		REACT_APP_ENV = Environments.STAGING;
	} else if (projectSubdomain === CommonSubdomains.SANDBOX) {
		// Sandbox-specific settings
		REACT_APP_ENV = Environments.SANDBOX;
	}

	const isDevelopmentEnv = REACT_APP_ENV === Environments.INTEGRATION || REACT_APP_ENV === Environments.STAGING;

	const AI_FORGE_API_BASE_URL = isDevelopmentEnv
		? 'https://forge-dev.proxy.sportal365.com/api/cms'
		: 'https://forge.proxy.sportal365.com/api/cms';
	const AI_FORGE_API_BASE_AUTH = isDevelopmentEnv
		? 'Basic YWRtaW5fZGV2OiZuWW5yXzAyclhXTVk1cjFZSlNRMGM='
		: 'Basic YWRtaW5fcHJvZDoyQl5pcGx4T0d1NkE1dEMpZXdRRjVC';

	return {
		PORT: 3000,
		CHOKIDAR_USEPOLLING: true,
		REACT_APP_OAUTH_CLIENT_ID: 100,
		REACT_APP_OAUTH_CLIENT_SECRET: 'JI6LgFTJrBJZ1snMzMIXAHMAC71DpeyvEvis6UHJ',
		REACT_APP_OAUTH_GRANT_TYPE: 'password',
		REACT_APP_CONTENT_API_BASE_URL: `https://content.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_CLIENT_API_BASE_URL: `https://client.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_IMAGE_API_BASE_URL: `https://image.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_NEWS_FEED_URL: `https://newsfeed.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_AUTO_TAGGING_URL: `https://autotagging.api${projectSubdomain}.sportal365.com`,
		REACT_APP_STATISTICS_API_BASE_URL: `https://statistic.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_WIDGETS_CDN_URL: 'https://widgets.sportal365.com',
		REACT_APP_IMAGO_PROXY_URL: 'https://imago.proxy.sportal365.com',
		REACT_APP_CONTENT_ANALYTICS_BASE_URL: `https://content-statistics.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_CUSTOMIZATION_API_BASE_URL: `https://customization.api${projectSubdomain}.sportal365.com`,
		REACT_APP_SEARCH_API_BASE_URL: `https://sports-search.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_BASKETBALL_API_URL: `https://basketball.api${projectSubdomain}.sportal365.com`,
		REACT_APP_ODDS_API_URL: `https://odds.api${projectSubdomain}.sportal365.com`,
		REACT_APP_WIDGETS_LOADER_API_URL: 'https://widgets.sportal365.com/loader.bundle.min.js',
		REACT_APP_TENNIS_API_URL: `https://tennis.api${projectSubdomain}.sportal365.com`,
		REACT_APP_HOCUS_POCUS_WEB_SOCKET_URL: `wss://collaboration.api${projectSubdomain}.sportal365.com/ws:443`,
		REACT_APP_ENV,
		REACT_APP_ENV_SUBDOMAIN: projectSubdomain,
		REACT_APP_STANDING_API_URL: `https://standing.api${projectSubdomain}.sportal365.com`,
		REACT_APP_MULTISPORT_API_URL: `https://multi-sport.api${projectSubdomain}.sportal365.com`,
		REACT_APP_ARTICLE_SCHEDULER_API_BASE_URL: `https://article-scheduler.api${projectSubdomain}.sportal365.com/`,
		REACT_APP_CONTENT_AI_FORGE_API_BASE_URL: AI_FORGE_API_BASE_URL,
		REACT_APP_CONTENT_AI_FORGE_API_AUTH: AI_FORGE_API_BASE_AUTH,
		REACT_APP_GET_FOOTBALL_API_AUTH: () => localStorage.getItem('football-api-token'),
		REACT_APP_GET_AUTO_TAGGING_V2_API_AUTH: () => localStorage.getItem('autotagging-api-v2-token'),
		REACT_APP_GET_CLIENT_AUTH: () => localStorage.getItem('client-api-token'),
		REACT_APP_GET_MULTISPORT_AUTH: () => localStorage.getItem('multisport-api-token'),
		REACT_APP_GET_ADMIN_MULTISPORT_AUTH: () => localStorage.getItem('multisport-api-admin-token'),
		REACT_APP_GET_STATISTICS_API_AUTH: () => localStorage.getItem('statistics-api-token'),
		REACT_APP_GET_SEARCH_AUTH: () => localStorage.getItem('search-api-token'),
		REACT_APP_GET_CUSTOMIZATION_API_AUTH: () => localStorage.getItem('customization-api-token'),
		REACT_APP_GET_ARTICLE_SCHEDULER_API_AUTH: () => localStorage.getItem('multisport-api-token'),
	};
})();

window['getReactAppUrls'] = () => {
	const state = store.getState();

	if (!state.profile.profile.id) {
		return 'Please log in to access REACT_APP_URLS.';
	}

	return REACT_APP_URLS;
};

export default REACT_APP_URLS;
